import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M448 170.667v91.648l-27.435 10.496a255.659 255.659 0 00-69.93 40.448l-22.784 18.517-79.446-45.867-64 110.848 79.36 45.824-4.608 28.971a258.219 258.219 0 000 80.896l4.608 28.97-79.36 45.825 64 110.848 79.446-45.867 22.784 18.517a255.27 255.27 0 0069.973 40.448L448 761.685v91.648h128v-91.648l27.435-10.496a255.659 255.659 0 0069.93-40.448l22.784-18.517 79.446 45.867 64-110.848-79.36-45.824 4.608-28.971a258.219 258.219 0 000-80.896l-4.608-28.97 79.36-45.825-64-110.848-79.446 45.867-22.784-18.517a255.659 255.659 0 00-69.973-40.448L576 262.315v-91.648H448zm170.667 62.293a298.368 298.368 0 0181.621 47.19l90.923-52.523 106.666 184.746-90.88 52.48a300.885 300.885 0 010 94.294l90.88 52.48-106.666 184.746-90.923-52.48a298.368 298.368 0 01-81.621 47.147V896H405.333V791.04a298.368 298.368 0 01-81.621-47.19l-90.923 52.523-106.666-184.746 90.88-52.48a300.885 300.885 0 010-94.294l-90.88-52.48 106.666-184.746 90.923 52.48a298.368 298.368 0 0181.621-47.147V128h213.334v104.96zM512 597.333a85.333 85.333 0 100-170.666 85.333 85.333 0 000 170.666zM512 640a128 128 0 110-256 128 128 0 010 256z"
});

function SvgWindowset(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "windowset_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowset);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'WindowsetOutlined';

export default KuFoxIcons;
